import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d397bc6c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=d397bc6c&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=d397bc6c&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d397bc6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d397bc6c')) {
      api.createRecord('d397bc6c', component.options)
    } else {
      api.reload('d397bc6c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d397bc6c&scoped=true", function () {
      api.rerender('d397bc6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/dashboard-design/charts/index.vue"
export default component.exports